import { render, staticRenderFns } from "./AddPayment.vue?vue&type=template&id=afcb1576&scoped=true"
import script from "./AddPayment.vue?vue&type=script&lang=js"
export * from "./AddPayment.vue?vue&type=script&lang=js"
import style0 from "./AddPayment.vue?vue&type=style&index=0&id=afcb1576&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afcb1576",
  null
  
)

export default component.exports